var chunkMapping = {
	"0": [
		4648
	],
	"3": [
		4055,
		4348
	],
	"79": [
		5084
	],
	"164": [
		5171
	],
	"165": [
		5172
	],
	"168": [
		5175
	],
	"169": [
		5176
	],
	"170": [
		5177
	],
	"171": [
		5178
	],
	"172": [
		5179
	],
	"173": [
		5180
	],
	"174": [
		5181
	],
	"175": [
		5182
	],
	"176": [
		5183
	],
	"177": [
		5184
	],
	"178": [
		5185
	],
	"179": [
		5186
	],
	"180": [
		5187
	],
	"181": [
		5188
	],
	"182": [
		5189
	],
	"183": [
		5190
	],
	"184": [
		5191
	],
	"185": [
		5192
	],
	"186": [
		5193
	],
	"187": [
		5194
	]
};
var idToExternalAndNameMapping = {
	"4055": [
		"default",
		"./nuorder-components",
		3670
	],
	"4348": [
		"default",
		"./helios-components",
		3670
	],
	"4648": [
		"default",
		"./Containers",
		3580
	],
	"5084": [
		"default",
		"./OrderlessInvoices",
		3580
	],
	"5171": [
		"default",
		"./AsyncEventTracker",
		3580
	],
	"5172": [
		"default",
		"./HostWrapper",
		3580
	],
	"5175": [
		"default",
		"./CheckoutV3",
		3580
	],
	"5176": [
		"default",
		"./CheckoutConfirmation",
		3580
	],
	"5177": [
		"default",
		"./ContactCreditCards",
		3580
	],
	"5178": [
		"default",
		"./AuditDialog",
		3580
	],
	"5179": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3580
	],
	"5180": [
		"default",
		"./InvoiceDialog",
		3580
	],
	"5181": [
		"default",
		"./PaymentDueModal",
		3580
	],
	"5182": [
		"default",
		"./PaymentModal",
		3580
	],
	"5183": [
		"default",
		"./PaymentHistory",
		3580
	],
	"5184": [
		"default",
		"./PaymentConfigurations",
		3580
	],
	"5185": [
		"default",
		"./PaymentPreferences",
		3580
	],
	"5186": [
		"default",
		"./ManagePaymentProcessing",
		3580
	],
	"5187": [
		"default",
		"./MobilePaymentsWrapper",
		3580
	],
	"5188": [
		"default",
		"./PayPage",
		3580
	],
	"5189": [
		"default",
		"./Challenge",
		3580
	],
	"5190": [
		"default",
		"./ManagePaymentMethods",
		3580
	],
	"5191": [
		"default",
		"./LightspeedReports",
		3580
	],
	"5192": [
		"default",
		"./ActivateLightspeedPayments",
		3580
	],
	"5193": [
		"default",
		"./MarketingLandingPage",
		3580
	],
	"5194": [
		"default",
		"./ShippingPromotionsListContainer",
		3580
	]
};
var idToRemoteMap = {
	"4055": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3670
		}
	],
	"4348": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3670
		}
	],
	"4648": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5084": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5171": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5172": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5175": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5176": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5177": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5178": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5179": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5180": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5181": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5182": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5183": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5184": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5185": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5186": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5187": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5188": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5189": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5190": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5191": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5192": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5193": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	],
	"5194": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3580
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}